module.exports = __webpack_public_path__ + "img/ncdc_logo_2.e1bd87a6.png";